module.exports = __webpack_public_path__ + "img/pr3.f95e62f0.png";